import store from 'store';

const isDayBankHoliday = testDay => {
  const { bankHolidaysList } = store.getState();
  return bankHolidaysList.bankHolidays.some(bankHoliday => bankHoliday.date === testDay.valueOf());
};

export { isDayBankHoliday };
